<script>
	export let value = false;
	export let label = "";
</script>

<style>
	/* .list-group-item {
		padding-top: 0px;
		padding-bottom: 0.5em;
		color: black;
	} */
</style>

<li class="list-group-item" class:text-danger={value === 'Yes'}>
	<span class="mr-1">{label}:</span><strong>{value}</strong>
</li>
